import { useQuery } from "@tanstack/react-query";
import { personKeys } from "@/lib/query";
import { getJson } from "@/lib/time/api-client";
import type { PersonProfileView } from "@/schemas/profile";

/**
 * The signed-in person's warehouse card (GET /api/me/profile): photo and title for the header,
 * the details for Profile. Changes rarely; the server caches 10 minutes too.
 */
export function useMyProfile() {
  return useQuery({
    queryKey: personKeys.profile,
    queryFn: () => getJson<PersonProfileView>("/api/me/profile"),
    staleTime: 10 * 60_000,
  });
}
